module.exports = __webpack_public_path__ + "static/img/4.d6026e79.png";